// financialYearSlice.ts

import { createSlice } from '@reduxjs/toolkit';
import {
    FinancialYearState
} from './financialYearTypes';
import {
    createFinancialYear,
    deleteFinancialYear,
    fetchAllFinancialYears,
    fetchFinancialYearById,
    fetchFinancialYearsByCompanyId,
    updateFinancialYear
} from './financialYearActions';

const initialState: FinancialYearState = {
    financialYears: [],
    financialYearsByCompany:[],
    selectedFinancialYear: undefined,
    loading: false,
    error: undefined,
};

const financialYearSlice = createSlice({
    name: 'financialYear',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createFinancialYear.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(createFinancialYear.fulfilled, (state, action) => {
                state.loading = false;
                state.financialYears.push(action.payload);
            })
            .addCase(createFinancialYear.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch All
            .addCase(fetchAllFinancialYears.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAllFinancialYears.fulfilled, (state, action) => {
                state.loading = false;
                state.financialYears = action.payload.data;
            })
            .addCase(fetchAllFinancialYears.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch By ID
            .addCase(fetchFinancialYearById.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchFinancialYearById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedFinancialYear = action.payload;
            })
            .addCase(fetchFinancialYearById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(updateFinancialYear.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(updateFinancialYear.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.financialYears.findIndex(fy => fy.id === action.payload.id);
                if (index !== -1) {
                    state.financialYears[index] = action.payload;
                }
                if (state.selectedFinancialYear?.id === action.payload.id) {
                    state.selectedFinancialYear = action.payload;
                }
            })
            .addCase(updateFinancialYear.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Delete
            .addCase(deleteFinancialYear.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(deleteFinancialYear.fulfilled, (state, action) => {
                state.loading = false;
                state.financialYears = state.financialYears.filter(fy => fy.id !== action.payload);
                if (state.selectedFinancialYear?.id === action.payload) {
                    state.selectedFinancialYear = undefined;
                }
            })
            .addCase(deleteFinancialYear.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
        builder
            .addCase(fetchFinancialYearsByCompanyId.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchFinancialYearsByCompanyId.fulfilled, (state, action) => {
                state.loading = false;
                state.financialYearsByCompany = action.payload.data;
            })
            .addCase(fetchFinancialYearsByCompanyId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });;
    }
});

export default financialYearSlice.reducer;
